import { de, el, es, ru } from 'date-fns/locale';

export default {
    de,
    el,
    en: null,
    es,
    ru,
};
